import { createTheme } from '@mui/material/styles';

export const PRIMARY = '#0B224F';
export const NAV_BG = '#071739';
export const ACCENT = '#1B3A78';

export const theme = createTheme({
  palette: {
    primary: { main: PRIMARY, dark: NAV_BG, light: ACCENT, contrastText: '#fff' },
    secondary: { main: '#1976d2' },
    background: { default: '#f4f6fb' }
  },
  shape: { borderRadius: 8 },
  typography: {
    fontFamily: '"Inter", "Segoe UI", Roboto, sans-serif',
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 }
  },
  components: {
    MuiAppBar: { styleOverrides: { root: { backgroundColor: NAV_BG } } },
    MuiButton: { defaultProps: { disableElevation: true } }
  }
});
